// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"266559d5","186":"6ef44919","225":"7427ef35","272":"4d8f3e38","372":"1e7d9ae6","573":"17d2eaa1","738":"1a4cc67f","841":"6652866c","856":"a7b852c4","909":"12bc42b5"}[chunkId] + ".chunk.js";
};